document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initContadores();
  initGaleriaProducto();
  initVariantesProducto();
  initFAQ();
  initBarraCompra();
});

function initReveals() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  // Position-based reveal: works even where IntersectionObserver is unreliable
  // (in-app browsers, background tabs), so content is never left invisible.
  function revelarVisibles() {
    var limite = window.innerHeight * 0.95;
    els.forEach(function (el) {
      if (!el.classList.contains('mt-visible') && el.getBoundingClientRect().top < limite) {
        el.classList.add('mt-visible');
      }
    });
  }
  revelarVisibles();
  window.addEventListener('scroll', revelarVisibles, { passive: true });
  window.addEventListener('resize', revelarVisibles);
  document.addEventListener('visibilitychange', revelarVisibles);

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { observer.observe(el); });
  }
}

function initContadores() {
  var els = document.querySelectorAll('.mt-count[data-target]');
  if (!els.length) return;
  var animado = new WeakSet();
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting || animado.has(entry.target)) return;
      animado.add(entry.target);
      var el = entry.target;
      var target = parseFloat(el.getAttribute('data-target')) || 0;
      var decimals = el.getAttribute('data-decimals') ? parseInt(el.getAttribute('data-decimals'), 10) : 0;
      var duration = 1400;
      var start = null;
      function paso(ts) {
        if (!start) start = ts;
        var progreso = Math.min((ts - start) / duration, 1);
        var ease = 1 - Math.pow(1 - progreso, 3);
        var valor = target * ease;
        el.textContent = valor.toFixed(decimals).replace('.', decimals ? ',' : '');
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = target.toFixed(decimals).replace('.', decimals ? ',' : '');
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var principal = document.querySelector('[data-mt-galeria-principal]');
  var minis = document.querySelectorAll('[data-mt-galeria-mini]');
  if (!principal || !minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var full = mini.getAttribute('data-full');
      if (!full) return;
      principal.style.opacity = 0;
      setTimeout(function () {
        principal.src = full;
        principal.style.opacity = 1;
      }, 120);
      minis.forEach(function (m) { m.classList.remove('mt-mini-activa'); });
      mini.classList.add('mt-mini-activa');
    });
  });
}

function initVariantesProducto() {
  var wrap = document.querySelector('[data-mt-variantes]');
  if (!wrap) return;
  var dataEl = document.querySelector('[data-mt-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var selects = wrap.querySelectorAll('select[data-mt-opcion]');
  var idInput = document.querySelector('[data-mt-variant-id]');
  var precioEl = document.querySelector('[data-mt-precio]');
  var precioTachadoEl = document.querySelector('[data-mt-precio-tachado]');
  var botonComprar = document.querySelector('[data-mt-comprar]');

  function moneyFmt(cents) {
    return (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function actualizar() {
    var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
    var match = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });
    if (!match) return;
    if (idInput) idInput.value = match.id;
    if (precioEl) precioEl.textContent = moneyFmt(match.price);
    if (precioTachadoEl) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        precioTachadoEl.textContent = moneyFmt(match.compare_at_price);
        precioTachadoEl.style.display = '';
      } else {
        precioTachadoEl.style.display = 'none';
      }
    }
    if (botonComprar) {
      botonComprar.disabled = !match.available;
      botonComprar.textContent = match.available ? botonComprar.getAttribute('data-texto-disponible') : botonComprar.getAttribute('data-texto-agotado');
    }
    var barraPrecio = document.querySelector('.mt-barra-compra-precio');
    if (barraPrecio) barraPrecio.textContent = moneyFmt(match.price);
    var barraBoton = document.querySelector('[data-mt-barra-compra-boton]');
    if (barraBoton && botonComprar) {
      barraBoton.disabled = !match.available;
      barraBoton.textContent = botonComprar.textContent;
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  actualizar();
}

function initFAQ() {
  var items = document.querySelectorAll('[data-mt-faq-item]');
  if (!items.length) return;
  items.forEach(function (item) {
    var pregunta = item.querySelector('[data-mt-faq-pregunta]');
    if (!pregunta) return;
    pregunta.addEventListener('click', function () {
      var abierta = item.classList.contains('mt-faq-abierta');
      items.forEach(function (i) { i.classList.remove('mt-faq-abierta'); });
      if (!abierta) item.classList.add('mt-faq-abierta');
    });
  });
}

function initBarraCompra() {
  var barra = document.querySelector('[data-mt-barra-compra]');
  var botonReal = document.querySelector('[data-mt-comprar]');
  if (!barra || !botonReal) return;

  var boton = barra.querySelector('[data-mt-barra-compra-boton]');
  if (boton) {
    boton.addEventListener('click', function () {
      botonReal.click();
      botonReal.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  // Visible whenever the real button is off screen (above or below), so on
  // mobile there is always a way to buy without scrolling first — but hidden
  // once the footer comes into view so it never covers the footer links.
  var footer = document.querySelector('footer.footer');
  function actualizar() {
    var alto = window.innerHeight;
    var r = botonReal.getBoundingClientRect();
    var botonEnPantalla = r.bottom > 0 && r.top < alto;
    var footerEnPantalla = footer ? footer.getBoundingClientRect().top < alto : false;
    barra.classList.toggle('mt-barra-compra--visible', !botonEnPantalla && !footerEnPantalla);
  }
  window.addEventListener('scroll', actualizar, { passive: true });
  window.addEventListener('resize', actualizar);
  actualizar();
}
